
import React from 'react';
import { UserPlus, UserCheck } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FriendRequest } from '../types';

interface FriendshipButtonProps {
  memberId: string;
  userId: string | undefined;
  friendRequest?: FriendRequest;
  isFriend?: boolean;
  isPendingFriend?: boolean;
  onSendRequest: (recipientId: string) => void;
  onAcceptRequest: (requesterId: string) => void;
}

const FriendshipButton = ({ 
  memberId, 
  userId, 
  friendRequest, 
  isFriend,
  isPendingFriend,
  onSendRequest, 
  onAcceptRequest 
}: FriendshipButtonProps) => {
  // Skip for own profile or if not logged in
  if (!userId || userId === memberId) return null;
  
  if (isFriend) {
    // Users are connected
    return (
      <Badge variant="outline" className="bg-green-50 text-green-800 ml-2">
        <UserCheck size={16} className="mr-1" /> Connected
      </Badge>
    );
  } else if (isPendingFriend) {
    // Current user sent the request - show pending status
    return (
      <Badge variant="secondary" className="ml-2">
        Request Sent
      </Badge>
    );
  } else if (friendRequest && friendRequest.status === 'pending') {
    if (friendRequest.requester_id === userId) {
      // Current user sent the request - show pending status
      return (
        <Badge variant="secondary" className="ml-2">
          Request Sent
        </Badge>
      );
    } else {
      // Current user received the request - show accept button
      return (
        <Button 
          size="sm" 
          variant="outline" 
          onClick={() => onAcceptRequest(memberId)}
          className="ml-2"
        >
          <UserCheck size={16} className="mr-1" /> Accept
        </Button>
      );
    }
  } else {
    // No request exists - show "Send Friend Request" button
    return (
      <Button 
        size="sm" 
        variant="outline" 
        onClick={() => onSendRequest(memberId)}
        className="ml-2"
      >
        <UserPlus size={16} className="mr-1" /> Connect
      </Button>
    );
  }
};

export default FriendshipButton;
